import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PaymentMethodConfig, PaymentMethodOption, PaymentOption, PaymentOptionType, PayoutOptionCode } from './payment-method.models';
import { Labels } from 'src/app/app.models';
import { ConfigFlags, Options, ServiceOptionsState } from 'src/app/store/service-options';
import { Store } from '@ngrx/store';
import { SetPaymentOption } from 'src/app/store/transaction';

@Component({
    selector: 'app-payment-method',
    templateUrl: './payment-method.component.html',
    styleUrls: ['./payment-method.component.scss'],
    standalone: false
})
export class PaymentMethodComponent {
  @Input() public google: any
  @Input() kind: string
  @Input() isSdfCardFlow: boolean = true
  @Input() labels: Labels
  @Input() public selectedPaymentMethod: PaymentOptionType | null

  private _serviceOptions: ServiceOptionsState
  @Input() public set serviceOptions(serviceOptions: ServiceOptionsState) {
    if (serviceOptions && this.config) {
      this.setEnabledOptions(serviceOptions)
    }
    this._serviceOptions = serviceOptions
  }
  public get serviceOptions() {
    return this._serviceOptions
  }

  @Input() public isLocationSelected: boolean | null;
  public config: PaymentMethodConfig

  constructor(private store: Store) {}

  ngOnInit(): void {
    this.config = {
      textHeader: this.labels.stellar.signIn.paymentMethods.paymentMethod,
      paymentMethodOptions: [
        {
          isEnabled: false,
          icon: 'assets/images/payment-method-icons/payment-method-cash-icon.svg',
          iconAltText: 'cash pickup-dropoff location icon',
          title: this.kind === 'withdraw' ? 'cashPickup' : 'cashAtLocation',
          subtitle: 'fee',
          displaySubtitle: false,
          fee: '$--.--',
          displayComingSoon: false,
          optionType: 'cash',
          payoutOptionCode: 'WILL_CALL',
          serviceOptionData: null
        },
        {
          isEnabled: false,
          icon: 'assets/images/payment-method-icons/payment-method-debit-icon.svg',
          iconAltText: 'payment method debit icon',
          title: 'debitCard',
          subtitle: 'fee',
          displaySubtitle: false,
          fee: '$--.--',
          displayComingSoon: false,
          optionType: 'debit',
          payoutOptionCode: 'DEBIT_CARD',
          serviceOptionData: null
        },
        {
          isEnabled: false,
          icon: 'assets/images/payment-method-icons/payment-method-bank-icon.svg',
          iconAltText: 'payment method bank account icon',
          title: 'bankAccount',
          subtitle: '',
          displaySubtitle: false,
          fee: '',
          displayComingSoon: true,
          optionType: 'bank',
          payoutOptionCode: 'BANK_DEPOSIT',
          serviceOptionData: null
        }
      ]
    }
    this.setEnabledOptions(this.serviceOptions)
  }

  public setPaymentMethod(paymentMethodOption: PaymentMethodOption): void {
    if (!paymentMethodOption) return
    if (paymentMethodOption.optionType === this.selectedPaymentMethod || !paymentMethodOption) return
    const paymentOption: PaymentOption = {
      optionType: paymentMethodOption.optionType,
      serviceOptionData: paymentMethodOption.serviceOptionData
    }
    this.store.dispatch(SetPaymentOption({ paymentOption }))
  }

  private setEnabledOptions(serviceOptions: ServiceOptionsState): void {
    this.config.paymentMethodOptions = this.config.paymentMethodOptions.map(optionConfig => {
      const payoutOption = this.kind === 'withdraw' ?
        serviceOptions.serviceOptions.find(opt => opt.payoutOptionCode === optionConfig.payoutOptionCode) :
        serviceOptions.serviceOptions[0]
      const updatedOptionConfig = {
        ...optionConfig,
        isEnabled: this.kind === 'withdraw' ? 
          !!payoutOption && this.isMethodEnabledInConfig(serviceOptions.config, payoutOption.payoutOptionCode as PayoutOptionCode) :
          this.isMethodEnabledInConfig(serviceOptions.config, optionConfig.payoutOptionCode),
          displaySubtitle: serviceOptions.features?.isPaymentOptionsSubtitleEnabled ?? false,
          serviceOptionData: payoutOption ?? null // Todo: Tim: #may6 - should there be a null case??
      }
      return updatedOptionConfig
    })
  }

  private isMethodEnabledInConfig(config: ConfigFlags | null, payoutOptionCode: PayoutOptionCode) {
    if (!config || !payoutOptionCode) return false
    if (payoutOptionCode === 'WILL_CALL') {
      return config.isCashEnabled
    }
    else if (payoutOptionCode === 'BANK_DEPOSIT') {
      return config.isBankAccountEnabled
    }
    // Todo: Tim: this value needs to be updated to the actual value returned
    else if (payoutOptionCode === 'DEBIT_CARD') {
      return config.isDebitEnabled
    }
    else {
      return false
    }
  }
}
